<ng-container *ngIf="days !== null">
  <ng-container [ngSwitch]="status">
    <span *ngSwitchCase="demurrageDetentionStatus.NoFreeDays">{{ days }}</span>
    <span *ngSwitchCase="demurrageDetentionStatus.Unprocessed">{{ days }}</span>
    <span *ngSwitchCase="demurrageDetentionStatus.Breached">
      {{
        'monitoring.demurrageDetention.daysOver'
          | translate : { days: days, remainingDays: remainingDays < 0 ? -remainingDays : remainingDays }
      }}
    </span>
    <span *ngSwitchDefault>
      <span *ngIf="remainingDays !== null; else justDays">
        {{ 'monitoring.demurrageDetention.daysLeft' | translate : { days: days, remainingDays: remainingDays } }}
      </span>
      <ng-template #justDays>{{ days }}</ng-template>
    </span>
  </ng-container>
</ng-container>